import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c(VMain,[(!_vm.error)?_c('router-view',{attrs:{"mode":_vm.mode,"first-visitor":_vm.firstVisitor}}):_c(VContainer,[_c(VLayout,{attrs:{"columns":"","fill-height":"","align-center":""}},[_vm._v("\n        "+_vm._s(_vm.error.status)+"\n        "),_c('p',[_vm._v(_vm._s(_vm.error.message))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }